import React from 'react';
import { useTranslation } from "react-i18next";
import BackContainer from './components/backContainer';
import TicketHeader from './components/header';
import Message from './components/message';
import { Button } from '../../ui';
import './resale.css';


export default function DeleteResale({ onSubmit = () => { }, config }) {
    const { t } = useTranslation();
    const { id: attendeeId } = config['resale-ticket-delete-form'].header;
    const [state, setState] = React.useState({ 'price': null, 'is_private_resale': null }); // eslint-disable-line

    const goToTicket = React.useCallback(() => {
        onSubmit(
            {
                data: {
                    action: 'previous',
                    payload: {
                        attendee_id: attendeeId
                    }
                }
            }
        )
    }
        , [onSubmit, attendeeId]);

    return (
        <div className='resale-container'>
            <BackContainer title={t('widget.resale.back-title')} onClick={goToTicket} />
            <TicketHeader data={config['resale-ticket-delete-form'].header} state={state} />

            <div className='wz-breakdown-container'>
                <div className='wz-breakdown-title'>{t('widget.resale.breakdown.title')}</div>
                <Message title={config['resale-ticket-delete-form'].message.title} description={config['resale-ticket-delete-form'].message.body} type={config['resale-ticket-delete-form'].message.type} />

                <div className='wz-breakdown-cta'>
                    <Button
                        className='wz-button wz-cancel-cta'
                        label={t('widget.resale.breakdown.cta-confirm')}
                        onClick={onSubmit}
                    />
                    <Button
                        className='wz-edit-cta'
                        label={t('widget.resale.breakdown.cta-back')}
                        onClick={goToTicket}
                    />
                </div>
            </div>
        </div>
    )
}